<template>
  <nav class="c-search-nav">
    <ul class="c-search-nav__container" aria-label="Search Results Tabs">
      <li
        class="c-search-nav__item"
        :class="activeIndex === index ? 'is-active' : null"
        v-for="(site, index) in sites"
        v-bind:key="index"
				:aria-current="activeIndex === index ? 'page' : undefined"
      >
        <button
          class="c-search-nav__button"
          v-on:click="getPageContent(index)"
        >
          {{ site.siteLabel }} <span>({{ site.totalResults }})</span>
        </button>
      </li>
    </ul>
    <p class="c-search-nav__description">{{ searchDescription }}</p>
  </nav>
</template>
<script>
export default {
  name: "SearchNav",
  props: {
    sites: {
      required: true,
      type: Array,
    },
    activeIndex: {
      required: true,
      type: Number,
    },
    searchDescription: {
      required: false,
      type: String,
    },
    totalResults: {
      type: Number,
    },
  },
  methods: {
    getPageContent(index) {
      this.$emit("getResults", index);
    },
  },
	watch: {
		sites(newVal) {
			console.log("update sites...", newVal)
		}
	},
};
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/results/SearchNav.vue